// extracted by mini-css-extract-plugin
module.exports = {"title":"_32ed2fb3","small":"_ba379d6c","medium":"_7ca72cce","large":"_95165b0e","xLarge":"_e114de36","xxLarge":"_26936ee","subtitle":"_87b83f7"};